import { Modal } from "../../atom/Modal";
import { FileUpload } from "../../atom/UploadFile";
import React from "react";
import { ParticipantFile } from "../../../types/components";
import { useTranslation } from "react-i18next";
import { usePostResource, usePutResource } from "../../../services";
import { toast } from "react-toastify";

interface UploadModalProps {
  isUploadModalOpen: boolean;
  setIsUploadModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  files: File[] | null;
  setFiles: React.Dispatch<React.SetStateAction<File[] | null>>;
  currentFile: ParticipantFile | null;
  mutate: () => void;
}

export const UploadFileModal: React.FC<UploadModalProps> = ({
  isUploadModalOpen,
  setIsUploadModalOpen,
  currentFile,
  setFiles,
  files,
  mutate,
}) => {
  const { t } = useTranslation();
  const { updateResource: trigger } = usePostResource("/file/upload/new");
  const { updateResource } = usePutResource(`/common/participant-file/${currentFile?.id}`);

  const uploadFile = async () => {
    const file = files?.[0];

    if (!file) {
      return;
    }

    if (file.type === "application/pdf" && currentFile?.type?.code === "certificate_krk") {
      toast.error(t("Only administrators can upload PDF files for KRK."));
      return;
    }

    const formData = new FormData();
    formData.append("UploadFiles", file);

    const uploadedFile: { data: ParticipantFile["file"] } = await trigger(formData);

    if (!uploadedFile) return;

    await updateResource({
      file_id: uploadedFile?.data?.id,
      is_uploading: true,
    });

    mutate();

    setFiles(null);
    setIsUploadModalOpen(false);
  };

  const handleClose = () => {
    setIsUploadModalOpen(false);
    setFiles(null);
  };

  return (
    <Modal
      isModalOpen={isUploadModalOpen}
      closeModal={handleClose}
      title={t("Upload and attach files")}
      subtitle=""
      secondButtonLabel={t("Attach Files")}
      secondButtonClick={uploadFile}
      firstButtonLabel={t("Cancel")}
      firstButtonClick={handleClose}
      contentClassName="w-[720px] pb-0"
      additionalClassName="w-fit !max-w-fit"
      content={
        <div>
          <FileUpload
            label=""
            files={files}
            allowedTypes={currentFile?.type?.allowed_file_types ?? ""}
            fileName={currentFile?.type.name}
            setFiles={(files) => setFiles(files as File[])}
            disabled={false}
          />
        </div>
      }
    />
  );
};
